import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib/store';
import {
  cancelExchangeAvailabilityRequest,
  failExchangeAvailability,
  setExchangeAvailability,
  setExchangeAvailabilityFromApi,
  updateExchangeAvailability,
  updateExchangeAvailabilityFromApi,
} from './exchange-availability.actions';

/**
 * Service to handle async ExchangeAvailability actions
 */
@Injectable()
export class ExchangeAvailabilityEffect {
  /**
   * Set the state with the reply content, dispatch failExchangeAvailability if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setExchangeAvailabilityFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setExchangeAvailability({ model: reply, requestId: action.requestId }),
        (error, action) => of(failExchangeAvailability({ error, requestId: action.requestId })),
        cancelExchangeAvailabilityRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failExchangeAvailability if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateExchangeAvailabilityFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateExchangeAvailability({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failExchangeAvailability({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
